/* -----------------UI--------------- */
import { Avatar } from "react-native-paper";

import Icon from "@react-native-vector-icons/material-design-icons/static";
/* -----------------Child components--------------- */
import type { IconType } from "../icon";
import ProductIcon from "./ProductIcon";

type Props = {
	icon: string;
};
const CardHeaderAvatar = ({ icon }: Props) => {
	const isHttps = icon?.startsWith("https");
	if (isHttps) {
		return <ProductIcon image={icon} size={44} />;
	}
	return (
		<Avatar.Icon
			style={{
				alignSelf: "center",
			}}
			size={40}
			icon={(props) => <Icon name={icon as IconType} {...props} />}
		/>
	);
};

export default CardHeaderAvatar;
